import classes from './App.module.css';
import logo from './Basecamp Finance-1-2.png';
import screenshot from './Basecampscreenshot.png';

function App() {
  return (
    <div className={classes.backdrop}>
      <div className={classes.header}>
        <img className={classes.logo} src={logo} alt="Basecamp logo" />
      </div>
      <div className={classes.container}>
        <div className={classes.info}>
          <div className={classes.copy}>
            A new era of finance
          </div>
          <div className={classes.subcopy}>
            A smart money manager that allows you to budget, save, and invest 
            all in one place. Create goals that appear as items on your budget,
            and automatically sweep your savings into safe investments
            so you can see your money grow over time.
          </div>
          <button className={classes.comingsoon}>
            Coming Soon
          </button>
        </div>
        <img className={classes.mainss} src={screenshot} alt="Screenshot of basecamp" />
      </div>
    </div>
  );
}

export default App;
